import React, { useEffect } from "react";
import PdfViewerModal from "./Home/Modals/PdfModal";

const Timeline = () => {
  // useEffect(() => {
  //   const options = {
  //     root: null,
  //     rootMargin: "-100px 0px -100px 0px",
  //     threshold: 0.3,
  //   };

  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add("active");

  //         // Find and activate `.line-grey` inside `.timeline-box`
  //         const lineGrey = entry.target
  //           .closest(".timeline-box")
  //           ?.querySelector(".line-grey");
  //         if (lineGrey) {
  //           lineGrey.classList.add("active");
  //         }
  //       } else {
  //         entry.target.classList.remove("active");

  //         // Remove active class from `.line-grey`
  //         const lineGrey = entry.target
  //           .closest(".timeline-box")
  //           ?.querySelector(".line-grey");
  //         if (lineGrey) {
  //           lineGrey.classList.remove("active");
  //         }
  //       }
  //     });
  //   }, options);

  //   document.querySelectorAll(".timeline-box").forEach((box) => {
  //     observer.observe(box);
  //   });

  //   return () => {
  //     document.querySelectorAll(".timeline-box").forEach((box) => {
  //       observer.unobserve(box);
  //     });
  //   };
  // }, []);

  return (
    <div id="roadmap">
      <div className="main Introducing pt-0 pt-md-5 pb-0 pb-md-0">
        <h2 className="text-center">
          Road <span>MAP</span>
        </h2>
        <p className="p">
        From Vision to Reality
        </p>
        {/* <div className="text-end d-flex justify-content-center">
          <div className="line"></div>
        </div> */}
        <div className="timeline">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="timeline-container">
                  <div className="timeline-continue">
                    {/* February 2025 */}
                    <div className="row timeline-right">
                      <div className="col-lg-6">
                        <div className="text-end d-flex justify-content-start justify-content-lg-end">
                          <div className="markers text-end"></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="timeline-box box-1 active">
                          <div className="timeline-text">
                            <h2>Presale Preparation</h2>
                            <div className="line-grey mb-3 active"></div>

                            <ul className="text-start">
                              <li>
                                Finalize tokenomics, whitepaper, and
                                documentation
                              </li>
                              <li>Deploy the OFNT token with a fixed supply</li>
                              <li>
                                Set up presale smart contract with 4-month
                                vesting (25% monthly)
                              </li>
                              <li>Launch investor dashboard</li>
                              <li>Complete contract audits and testing</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row timeline-left">
                      <div className="col-lg-6 d-lg-none d-block"></div>
                      <div className="col-lg-6">
                        <div className="timeline-box box-2 active">
                          <div className="timeline-text">
                            <h2>Token Presale Launch</h2>
                            <div className="d-flex align-items-center justify-content-start justify-content-lg-end">
                              <div className="line-grey mb-3 active"></div>
                            </div>
                            <ul className="text-start">
                              <li>Launch presale through dashboard</li>
                              <li>Enable live token purchases and tracking</li>
                              <li>Activate vesting system</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row timeline-right">
                      <div className="col-lg-6"></div>
                      <div className="col-lg-6">
                        <div className="timeline-box box-3">
                          <div className="timeline-text">
                            <h2>
                              Core Smart Contract Development
                            </h2>
                            <div className="line-grey mb-3"></div>
                            <ul className="text-start">
                              <li>Add emission logic with halving</li>
                              <li>
                                Launch staking and validator delegation system
                                (DPoS-style)
                              </li>
                              <li>
                                Create project submission and scoring features
                              </li>
                              <li>Introduce backer rewards</li>
                              <li>Complete internal and external audits</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row timeline-left">
                      <div className="col-lg-6 d-lg-none d-block"></div>
                      <div className="col-lg-6">
                        <div className="timeline-box box-4">
                          <div className="timeline-text">
                            <h2>
                              Backend Infrastructure & API Layer
                            </h2>
                            <div className="d-flex align-items-center justify-content-start justify-content-lg-end">
                              <div className="line-grey mb-3"></div>
                            </div>
                            <ul className="text-start">
                              <li>
                                Build APIs for emissions, staking, delegation,
                                project tracking, and vesting
                              </li>
                              <li>
                                Automate daily functions like reward
                                distribution and halving
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row timeline-right">
                      <div className="col-lg-6"></div>
                      <div className="col-lg-6">
                        <div className="timeline-box box-5">
                          <div className="timeline-text">
                            <h2>Dashboard Integration</h2>
                            <div className="line-grey mb-3"></div>
                            <ul className="text-start">
                              <li>
                                Integrate smart contract features into the user
                                dashboard
                              </li>
                              <li>
                                Staking, Delegation, Project Listings, Scoring,
                                Rewards
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row timeline-left">
                      <div className="col-lg-6 d-lg-none d-block"></div>
                      <div className="col-lg-6">
                        <div className="timeline-box box-6">
                          <div className="timeline-text">
                            <h2>
                              DEX/CEX listings and ecosystem rollout
                            </h2>
                            <div className="d-flex align-items-center justify-content-start justify-content-lg-end">
                              <div className="line-grey mb-3"></div>
                            </div>
                            <ul className="text-start">
                              <li>List OFNT on a DEX (e.g., PancakeSwap)</li>
                              <li>
                                Begin outreach for Tier 1 CEX listings (e.g.,
                                Binance)
                              </li>
                              <li>
                                Start validator, backer, and project onboarding
                                campaigns
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row timeline-right">
                      <div className="col-lg-6"></div>
                      <div className="col-lg-6">
                        <div className="timeline-box box-7">
                          <div className="timeline-text">
                            <h2>DAO governance, multi-chain upgrades, and expansion</h2>
                            <div className="line-grey mb-3"></div>
                            <ul className="text-start">
                              <li>Grow validator and project communities</li>
                              <li>Launch DAO for community governance</li>
                              <li>
                                Plan for multi-chain upgrades and V2 development
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 text-center justify-content-center d-flex  mb-4 ">
          <PdfViewerModal pdfUrl={"/whitepaper/OFNT-Whitepaper-updated.pdf"} />
        </div>
      </div>
    </div>
  );
};

export default Timeline;
